import styled from 'styled-components';

const TABLE_COLUMNS = `minmax(240px, 2.2fr) minmax(160px, 1.3fr) 90px
  minmax(150px, 1fr) minmax(270px, 1.8fr) minmax(180px, 1.2fr) 110px`;

export const Table = styled.div`
  width: 100%;
  overflow-x: auto;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: ${TABLE_COLUMNS};
  min-width: 1190px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;

  > span {
    padding: 12px 8px;
    font-weight: 500;
    color: #262626;
  }
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: ${TABLE_COLUMNS};
  align-items: start;
  min-width: 1190px;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }

  &[data-selected='true'] {
    background: #fff9eb;
  }
`;

export const Cell = styled.div`
  min-width: 0;
  padding: 12px 8px;
  font-size: 13px;
  color: #262626;
`;

export const ProductCell = styled(Cell)`
  display: flex;
  gap: 8px;
`;

export const Thumb = styled.div`
  flex: none;
  width: 56px;
`;

export const ProductName = styled.span`
  display: block;
  font-weight: 600;
  line-height: 1.3;
  overflow-wrap: anywhere;
`;

export const Concept = styled.span`
  display: block;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const Secondary = styled.span`
  display: block;
  font-size: 12px;
  color: #8c8c8c;
`;

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
`;

export const Notes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;
`;

export const Subtotal = styled.span`
  font-weight: 700;
`;

export const Quantity = styled.div`
  width: 100%;

  .ant-form-item,
  .ant-form-item-control,
  .ant-input-group-wrapper {
    width: 100%;
  }

  && .ant-form-item-control-input-content {
    flex: auto;
    width: 100%;
  }
`;

export const Hint = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #8c8c8c;
`;

export const CardList = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const CardButton = styled.button`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  padding: 12px;
  color: #262626;
  text-align: start;
  cursor: pointer;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;

  &[data-selected='true'] {
    border-color: #f78e1e;
  }

  &:focus-visible {
    outline: 2px solid #f78e1e;
    outline-offset: 2px;
  }
`;

export const CardHeader = styled.span`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

export const CardTitle = styled.span`
  display: block;
  min-width: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  overflow-wrap: anywhere;
`;

export const CardTotal = styled.span`
  flex: none;
  font-size: 14px;
  font-weight: 700;
`;

export const CardDetails = styled.span`
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  align-items: center;
  font-size: 12px;
  color: #595959;
`;

export const CardTag = styled.span`
  align-self: flex-start;
  padding: 0 8px;
  font-size: 12px;
  line-height: 20px;
  color: #d16d0f;
  background: #fff9eb;
  border: 1px solid #ffd899;
  border-radius: 4px;
`;

export const SheetBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SheetImage = styled.div`
  display: flex;
  justify-content: center;
`;

export const DetailList = styled.dl`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px 12px;
  align-items: center;
  margin: 0;

  dt {
    font-size: 12px;
    color: #8c8c8c;
  }

  dd {
    min-width: 0;
    margin: 0;
    font-size: 14px;
  }
`;

export const SheetSection = styled.section`
  > h3 {
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 600;
  }

  .ant-input,
  .ant-input-group-addon {
    height: 44px;
  }

  .ant-btn {
    min-height: 44px;
  }
`;

export const SheetAction = styled.button`
  width: 100%;
  height: 44px;
  font: inherit;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  background: #f78e1e;
  border: 1px solid #f78e1e;
  border-radius: 2px;
`;
